module.exports = __webpack_public_path__ + "img/three_forty_five.52b57c25.svg";